import {
  iwIconDrawPoint,
  iwIconPodgladMapa,
  iwIconRysujWielobok,
} from '../../../../../../assets/css/ewid-svg/svg-icons';
import {
  ColumnSetting,
  ColumnType,
  GenericToolbarItemName,
  GridToolBarItem,
} from '../../../../../../gk-kendo';
import { AnyGeometryObject } from '../../../../../models';
import { StreetAxisDetailsGridDto } from './street-axis-details-grid-data-model';
import { StreetAxisDetailsGridComponent } from './street-axis-details-grid.component';

export const getStreetAxisDetailsGridToolbarItems = (
  c: StreetAxisDetailsGridComponent,
): GridToolBarItem[] => {
  return [
    {
      name: GenericToolbarItemName.GetPointGeometryFromMap,
      svgIcon: iwIconPodgladMapa,
      className: 'svg-icon-blue',
      title: 'GENERIC_TOOLBAR_ITEM.ADD_LAND_FROM_MAP',
      text: 'GENERIC_TOOLBAR_ITEM.ADD_LAND_FROM_MAP',
      showText: 'overflow',
      payload: () => ({
        doneCallback: (anyGeometryObject: AnyGeometryObject[]): void => {
          c.addPointGeometryFromMap(anyGeometryObject[0].geom);
        },
      }),
    },
    {
      name: GenericToolbarItemName.GetPolygonGeometryFromMap,
      svgIcon: iwIconRysujWielobok,
      className: 'svg-icon-blue',
      title: 'GENERIC_TOOLBAR_ITEM.SEARCH_BY_MARK_RANGE',
      text: 'GENERIC_TOOLBAR_ITEM.SEARCH_BY_MARK_RANGE',
      showText: 'overflow',
      payload: () => ({
        doneCallback: (anyGeometryObject: AnyGeometryObject[]): void => {
          c.addPointGeometryFromMap(anyGeometryObject[0].geom);
        },
      }),
    },
    {
      name: GenericToolbarItemName.GetLineGeometryFromMap,
      svgIcon: iwIconDrawPoint,
      className: 'svg-icon-blue',
      title: 'GENERIC_TOOLBAR_ITEM.DRAW_LINE_ON_MAP',
      text: 'GENERIC_TOOLBAR_ITEM.DRAW_LINE_ON_MAP',
      showText: 'overflow',
      payload: () => ({
        doneCallback: (anyGeometryObject: AnyGeometryObject[]): void => {
          c.addPointGeometryFromMap(anyGeometryObject[0].geom);
        },
      }),
    },
  ];
};

export const streetAxisDetailsGridColumns: ColumnSetting[] = [
  {
    field: 'Ulica',
    title: 'STREET_AXIS_DETAILS.GRID.STREET_AXIS',
    type: ColumnType.Text,
    cellTemplate: (_item, dataItem: StreetAxisDetailsGridDto): string =>
      `Oś - ul. ${dataItem.Miejscowosc}`,
  },
];
